<template>
  <div class="content-wrap">
    <section>
      <h1>ミツカル サービス利用規約</h1>
      <h2>第1条（規約）</h2>
      <p>本規約は、ケイアイスター不動産株式会社（以下、｢当社｣という。）が運営する不動産・住宅に関する総合情報サイト「ミツカル」（以下、｢本サービス｣という。）のご利用について規定したものです。以下、本サービスで提供される各種サービスを利用するすべてのユーザーに適用されるものとし、ユーザーが本サイトを利用したことをもって本規約に同意したものとみなします。</p>
      <p>また、当社が、本サイトで提示する諸注意等(以下、「諸注意等」という。）が存在する場合には、諸注意等はそれぞれ本規約の一部構成するものとします。</p>
      <h2>第2条（禁止事項）</h2>
      <p>本サービスの利用に際して、ユーザーは次の各号の行為を行ってはいけません。万一、ユーザーが次の各号の行為を行い当社に損害が生じたときは、当社は、当該ユーザーのサービス利用停止・中止及び本規約第５条に定める利用停止をすることができます。また、当該ユーザーの行為により当社に損害が生じたときは、当該ユーザーに損害賠償を請求する場合があります。</p>
      <ul>
        <li>（1）公序良俗または法令・本規約等に違反する行為</li>
        <li>（2）当社または第三者の権利、利益、名誉等を損ねる行為</li>
        <li>（3）第三者に迷惑となる行為や不快感を抱かせる行為</li>
        <li>（4）有害なコンピュータプログラム、メール等を送信または書き込む行為</li>
        <li>（5）当社のサーバその他のコンピュータに不正にアクセスする行為</li>
        <li>（6）本サービスから得た情報を商業目的に使用したり、その情報を販売したりする行為</li>
        <li>（7）その他前各号に準ずると当社が認めた行為</li>
      </ul>
      <h2>第3条（個人情報の取扱い）</h2>
      <p>当社は、当社のプライバシーポリシーに記載する<a href="https://ki-group.co.jp/policy/">「個人情報の取り扱い」</a>に従い、適切に個人情報を取り扱います。</p>

      <h2>第4条（サービスの中断・停止等）</h2>
      <p>当社は、本サービスを常に良好な状態でご利用いただくために、システムの定期保守や緊急保守を行う場合、システムに負荷が集中した場合、サービスの運営に支障が生じると当社が判断した場合、ユーザーのセキュリティを確保する必要が生じた場合、その他必要があると判断した場合には、事前に通知することなく、本サービスの全部または一部の提供を中断または停止する等の必要な措置を取ることができるものとします。この場合にユーザーに生じた損害について、当社は一切責任を負いません。</p>
      <h2>第5条（利用停止）</h2>
      <p>当社は、特定のユーザーが次の各号に該当すると判断した場合には、事前に通知することなく本サービス利用の停止を行うことができるものとします。これによりユーザーに何らかの損害が生じたとしても、当社は一切責任を負いません。</p>
      <ul>
        <li>（1）ユーザーに法令や本規約等に違反する行為があった場合</li>
        <li>（2）ユーザーに本サービス利用に関して不正行為があった場合</li>
        <li>（3）ユーザーが当社の同業他社であることが判明した場合</li>
        <li>（4）その他、当社が本サービス利用停止等の措置が必要であると判断した場合</li>
      </ul>
      <h2>第6条（反社会的勢力の排除）</h2>
      <p>当社は、反社会的勢力及びその関係者のサービス利用をお断りいたします。本サービス利用後であっても当社が反社会的勢力及びその関係者であると判断した場合、当社は本サービス利用停止等の措置を行うことができるものとします。</p>
      <h2>第7条（当社の免責）</h2>
      <p>当社は、当社の故意または重過失によらない場合には、本サービスの利用により生じたユーザーの損害について、免責されるものとします。また、当社は、本サービスに掲載されているコンテンツの内容について妥当性や正確性等について保証するものではなく、一切の責任を負い兼ねます。万一、ユーザーにつき当該情報に関して何らかのトラブルが生じた場合にも、当該トラブルが当社の責に帰すべき事由による場合を除き、当社は何ら責任を負いません。</p>
      <h2>第8条（本規約の改訂、補充）</h2>
      <p>当社は、本規約を任意に改訂できるものとし、また、当社において本規約を補充する規約（以下、「補充規約」という。）を定めることができるものとします。当社は本規約の改訂および補充規約を、あらかじめ本サイトまたは当社所定のサイトに掲示するものとし、同掲示に示した効力発生日が到来したときにその効力を生じるものとします。この場合、効力発生日到来後に本サービスを利用したユーザーは、改訂後の本規約および補充規約に承諾をしたものとみなします。</p>
      <h2>第9条（準拠法、合意管轄）</h2>
      <p>本規約は日本法に基づき解釈されるものとし、本規約等に関し訴訟の必要が生じた場合には、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>
      <h2>第10条（知的財産権）</h2>
      <p>本サービスを通じて提供されるテキスト・写真・画像・動画等の情報やサービスに関する著作権その他知的財産権（以下、「情報その他知的財産権等」という。）は、当社または当社が使用の許諾を得た権利者に帰属し、著作権法、商標法、意匠法等により保護されています。<br />
      ユーザーは、本サービスを通じて提供されるいかなる情報その他知的財産権等も私的使用の範囲外では使用できないものとします。<br />
      ユーザーは、当社の事前の承諾を得ず、本サービスを通じて提供を受けたいかなる情報その他知的財産権等も、第三者に提供したり使用させたりしてはならないものとします。<br />
      ユーザーは、本サービスを通じて提供される著作権その他知的財産権を無断で複製、転用、改ざん、配布などを行うことはできません。</p>
      <p style="text-align:right">制定&nbsp;2021年2月15日</p>
    </section>
  </div>
</template>

<script>
import IsMobileMixin from '@/plugins/isMobile';

export default {
  name: 'StaticContentsTerm',
  mixins: [IsMobileMixin],
  data() {
    return {};
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
@charset "UTF-8";
h1 {
  font-family: "メイリオ", "Meiryo", sans-serif;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 27px;
}
h2 {
  font-size: 18px;
  font-weight: bold;
  // padding: 17px 0 20px;
  text-align: center;
  background-color: #f6f6f6;
  margin-bottom: 20px;
  margin-top: 40px;
}
h3 {
  margin-bottom: 9px;
  font-size: 14px;
  font-weight: bold;
  margin-top: 27px;
}
p {
  font-size: 14px;
  margin-bottom: 27px;
}
.content-wrap {
  line-height: 1.6em;
}
.breadcrumb {
  margin-bottom: 22px;
  margin-left: 41px;
  color: #707070;
}
.breadcrumb a {
  color: #e83532;
  text-decoration: none;
  font-size: 12px;
}
.align-center {
  text-align: center;
  margin-bottom: 31px;
}
.to-the-top {
  text-align: center;
  color: #666666;
  background-color: #fff;
  border: #707070 1px solid;
  border-radius: 100vh;
  padding: 13px 60px;
  text-decoration: none;
  display: none;
}

@media screen and (max-width: 639px) {
  body {
    background-color: #ffffff;
    padding-top: 0;
  }
  .breadcrumb {
    margin: 0 14px 34px;
  }
  .to-the-top {
    display: initial;
  }
}
</style>
